import { Alert, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuth } from '../../auth/AuthProvider';
import { PageHeader } from '../../components/states';
import { useNotify } from '../../lib/notify';
import { MfaSetupFlow } from './MfaSetupFlow';

/** Voluntary enrolment from the account page (`/account/mfa`). */
export function MfaSetupPage() {
  const { me } = useAuth();
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <>
      <PageHeader
        eyebrow="Account & security"
        title="Two-step verification"
        subtitle="Protect your platform account with a code from your phone at every sign-in."
      />
      {me?.mfaEnabled ? (
        <Alert severity="success">Two-step verification is already on for this account.</Alert>
      ) : (
        <Card sx={{ maxWidth: 860 }}>
          <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
            <MfaSetupFlow
              onDone={() => {
                notify.success('Two-step verification is on');
                void navigate('/account');
              }}
            />
          </CardContent>
        </Card>
      )}
    </>
  );
}
